import { render, staticRenderFns } from "./edit_form.vue?vue&type=template&id=2b053c58&scoped=true&"
import script from "./edit_form.vue?vue&type=script&lang=js&"
export * from "./edit_form.vue?vue&type=script&lang=js&"
import style0 from "./edit_form.vue?vue&type=style&index=0&id=2b053c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b053c58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b053c58')) {
      api.createRecord('2b053c58', component.options)
    } else {
      api.reload('2b053c58', component.options)
    }
    module.hot.accept("./edit_form.vue?vue&type=template&id=2b053c58&scoped=true&", function () {
      api.rerender('2b053c58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/net_bar/device/edit_form.vue"
export default component.exports